module.exports = __webpack_public_path__ + "img/undraw_quiz_nlyh.2cde90cb.svg";